import Cookies from 'js-cookie'
import { UMOOC_COOKIE_DOMAIN } from '@/config'

const defaultCookieSetting = {
  expiredays: null,
  path: '/',
  domain: UMOOC_COOKIE_DOMAIN
}

const cookies = {}

/**
 * @description 存储 cookie 值
 * @param {String} name cookie name
 * @param {String} value cookie value
 * @param {Object} setting cookie setting
 */
cookies.set = (name = 'default', value = '', cookieSetting = {}) => {
  // Object.assign(defaultCookieSetting, cookieSetting)
  // Cookies.set(`${name}`, value, defaultCookieSetting)
  // domain只能设置为当前域名的更高级域名，
  // 如：在www.tongshike.cn中可以设置为.tongshike.cn而不能设置为ua.tongshike.cn
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + defaultCookieSetting.expiredays);
  document.cookie =
  name +
    "=" +
    encodeURIComponent(value) +
    (defaultCookieSetting.expiredays == null ? "" : "; expires=" + exdate.toGMTString()) +
    (defaultCookieSetting.path == null ? "" : "; path=" + encodeURIComponent(defaultCookieSetting.path)) +
    (defaultCookieSetting.domain == null ? "" : "; domain=" + encodeURIComponent(defaultCookieSetting.domain));
  
}


/**
 * @description 拿到 cookie 值
 * @param {String} name cookie name
 */
 cookies.get = (name = 'default') => {
  // return Cookies.get(`${name}`)
  let cookie = Cookies.withConverter(function(value, name) {
    return decodeURIComponent(value)
  })
  return cookie.get(`${name}`)
}

/**
 * @description 拿到 cookie 全部的值
 */
cookies.getAll = () => {
  return Cookies.get()
}

/**
 * @description 删除 cookie
 * @param {String} name cookie name
 * @param {Object} setting cookie setting
 */
cookies.remove = (name = 'default', setting = defaultCookieSetting) => {
  return Cookies.remove(`${name}`, setting)
}

/**
 * @description 删除 所有cookie
 * @param {Object} setting cookie setting
 */
cookies.removeAll = (setting = defaultCookieSetting) => {
  const arr = cookies.getAll()
  for (const key in arr) {
    cookies.remove(key, setting)
  }
}



export default cookies
